(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvara-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tvara-shop-look')) {
    customElements.define(
      'tvara-shop-look',
      class extends HTMLElement {
        connectedCallback() {
          this.hydrate();
          this.track = this.querySelector('.tvara-shop-look__track');
          this.hotspots = [...this.querySelectorAll('.tvara-shop-look__hotspot')];
          this.arrows = [...this.querySelectorAll('.tvara-shop-look__arrow')];
          this.buy = this.querySelector('.tvara-shop-look__buy');
          if (!this.track) return;

          this.hotspots.forEach((h) => h.addEventListener('click', () => this.go(Number(h.dataset.index))));
          this.arrows.forEach((a) => a.addEventListener('click', () => this.go(this.current() + Number(a.dataset.step))));
          this.track.addEventListener('scroll', () => this.sync(), { passive: true });
          this.buy?.addEventListener('click', () => this.addAll());
          // theme editor: selecting a hotspot block shows its product
          this.onBlockSelect = (e) => {
            const i = [...this.track.children].findIndex((s) => s.dataset.blockId === e.detail.blockId);
            if (i > -1) this.go(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          // back/forward cache restores the page with the button still disabled
          this.onPageShow = () => this.buy && (this.buy.disabled = false);
          window.addEventListener('pageshow', this.onPageShow);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          window.removeEventListener('pageshow', this.onPageShow);
        }

        // collection-grid block: hotspots are child blocks the parent can't read in Liquid, so build hotspots/total from the slides
        hydrate() {
          const slides = [...this.querySelectorAll('.tvara-shop-look__slide[data-x]')];
          if (!slides.length || this.querySelector('.tvara-shop-look__hotspot')) return;
          const media = this.querySelector('.tvara-shop-look__media');
          slides.forEach((s, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'tvara-shop-look__hotspot';
            b.dataset.index = i;
            b.style.cssText = `--x: ${s.dataset.x}%; --y: ${s.dataset.y}%;`;
            b.setAttribute('aria-label', `Show ${s.dataset.title}`);
            b.setAttribute('aria-pressed', String(i === 0));
            media.append(b);
          });
          const count = this.querySelector('[data-count]');
          if (count) count.textContent = slides.length;
          const buy = this.querySelector('.tvara-shop-look__buy');
          const sold = slides.filter((s) => s.dataset.variantId);
          if (!buy) return;
          if (!sold.length) return buy.remove();
          buy.dataset.ids = sold.map((s) => s.dataset.variantId).join(',');
          const cents = sold.reduce((t, s) => t + Number(s.dataset.price), 0);
          // shortcut: INR-only formatting (matches the section's Rs.→₹ swap), switch to shop money_format if multi-currency
          buy.querySelector('[data-total-price]').textContent =
            '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: cents % 100 ? 2 : 0 });
        }

        current() {
          return Math.round(this.track.scrollLeft / this.track.clientWidth) || 0;
        }

        go(i) {
          const max = this.track.children.length - 1;
          this.track.scrollTo({ left: Math.max(0, Math.min(i, max)) * this.track.clientWidth });
        }

        sync() {
          const i = this.current();
          this.hotspots.forEach((h, n) => h.setAttribute('aria-pressed', String(n === i)));
          if (this.arrows.length) {
            this.arrows[0].disabled = i === 0;
            this.arrows[1].disabled = i === this.track.children.length - 1;
          }
          const counter = this.querySelector('[data-current]');
          if (counter) counter.textContent = i + 1;
        }

        async addAll() {
          const btn = this.buy;
          const error = btn.nextElementSibling;
          if (btn.disabled) return;
          btn.disabled = true;
          error.textContent = '';
          const items = btn.dataset.ids.split(',').map((id) => ({ id: Number(id), quantity: 1 }));
          try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items }),
            });
            if (!res.ok) throw new Error((await res.json()).description || res.status);
            window.location.href = btn.dataset.cartUrl;
          } catch (e) {
            error.textContent = e.message;
          } finally {
            btn.disabled = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
